let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6kXh6"), load("lPQcc"), load("kKNsN")]).then(() => parcelRequire('1vSpd'));